import { useState, useEffect } from 'react';
import Button from 'components/base/Button';
import { useNavigate, useParams } from 'react-router-dom';
import { Alert, Row, Col } from 'react-bootstrap';
import LoadingOverlay from 'components/loading-overlay/LoadingOverlay';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import PageBreadcrumb from 'components/common/PageBreadcrumb';
import { moveItem, getContainers, getItem } from 'api/api';

const breadcrumbItems = [
  {
    label: 'Items',
    url: '/weapons/weapons'
  },
  {
    label: 'Move',
    active: true
  }
];

const ItemChangeContainer = () => {
  const navigate = useNavigate();
  const animatedComponents = makeAnimated();
  const [error, setError] = useState([]);
  const [loading, setLoading] = useState(false);
  const [containerName, setContainerName] = useState([]);
  const [container_id, setContainer_id] = useState(null);
  const [current_container_id, setCurrent_container_id] = useState(null);
  const [current_container_name, setCurrent_container_name] = useState(null);
  const [itemName, setItemName] = useState(null);
  const { id } = useParams();

  useEffect(() => {
    const initialize = async () => {
      try {
        await loadContainers();
        await loadItem();
      } catch (err) {
        console.error(err);
      }
    };

    initialize();
  }, []);
  const loadItem = async () => {
    setError([]);
    setLoading(true);

    try {
      const response = await getItem(id);
      const data = response.data.data;
      setItemName(data.name);
      setCurrent_container_id(data.container.id);
      setCurrent_container_name(data.container.name);
    } catch (err) {
      try {
        setError(err.response.data.errors);
      } catch (ex) {
        setError(['Please try again later...']);
      }
    } finally {
      setLoading(false);
    }
  };

  const loadContainers = async () => {
    setError([]);
    setLoading(true);

    try {
      const response = await getContainers();
      const data = response.data.data.data;
      setContainerName(data);
    } catch (err) {
      try {
        setError(err.response.data.errors);
      } catch (ex) {
        console.log(ex);
        setError(['Please try again later...']);
      }
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = e => {
    e.preventDefault();

    setError([]);
    setLoading(true);

    const formData = {
      container_id: container_id.value
    };

    moveItem(id, formData)
      .then(response => {
        if (response.status === 200) navigate('/weapons/weapons');
      })
      .catch(err => {
        console.log(err.response);
        try {
          setError(err.response.data.errors);
        } catch (error) {
          setError(['Please try again later...']);
        }
      });

    setTimeout(function () {
      setLoading(false);
    }, 1000);
  };

  const customStyles = {
    singleValue: provided => ({
      ...provided,
      fontSize: '12px'
    })
  };

  return (
    <div>
      <PageBreadcrumb items={breadcrumbItems} />
      <div className="mb-9">
        <div className="d-flex flex-wrap gap-3 flex-between-end mb-5">
          <div>
            <h2 className="mb-2">{`Move '${itemName}' to different container`}</h2>
            <h5 className="text-700 fw-semi-bold">
              Current Container:
              <span style={{ marginLeft: '5px', fontWeight: 'bold' }}>
                {current_container_name}
              </span>
            </h5>
          </div>
        </div>
        <div>
          {Object.entries(error).length > 0 &&
            error.map((e, index) => (
              <Alert variant="soft-danger" key={index}>
                {e}
              </Alert>
            ))}
        </div>

        {loading && <LoadingOverlay />}

        <div>
          <form onSubmit={handleSubmit}>
            <Row>
              <Col xs={12} xl={4}>
                <label>Container*</label>
                <Select
                  className="mb-2"
                  classNamePrefix="react-select"
                  closeMenuOnSelect={true}
                  components={animatedComponents}
                  options={
                    containerName &&
                    containerName
                      .filter(c => c.id !== current_container_id)
                      .map(c => ({
                        value: c.id,
                        label: c.name
                      }))
                  }
                  value={container_id}
                  onChange={e => setContainer_id(e)}
                  required
                  name="container"
                  menuPlacement="auto"
                  styles={customStyles}
                />
              </Col>
            </Row>

            <Row style={{ marginTop: '10px' }}>
              <Col xs={12} xl={4}>
                <Button variant="primary" type="submit" className="mb-2">
                  Submit
                </Button>{' '}
                <Button
                  className="mb-2"
                  variant="phoenix-secondary"
                  type="button"
                  onClick={() => navigate('/weapons/weapons')}
                >
                  Discard
                </Button>
              </Col>
            </Row>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ItemChangeContainer;
